<template>
    <div class="content with-pagination">
        <router-view @refresh="refresh()"></router-view>
        <header class="content-header">
            <div class="wrapper">

                <div>
                    <h1>Tag</h1>
                    <p>Gestion des tags</p>

                    <div class="datagrid-results"><strong>{{paginator.total}}</strong> Résultats trouvés</div>
                </div>

              <actions-dropdown>
                <li v-if="$aclInterfaceValidator('weeboxcore.tag.create')" class="main" @click="create()">
                  <icon name="file-plus-02"/>
                  <span>Créer un tag</span>
                </li>
              </actions-dropdown>


            </div>
        </header>

        <filters v-model="filters" :paginator="paginator" active-advanced-filter="false" @refresh="refresh()" @setFilter="setFilter"></filters>

        <div class="content-body">

            <section>

                <no-results v-model="resources" :clear="resetFilter"></no-results>

            <div v-if="resources && resources.length" class="datagrid" :class="paginator.listing">
                <div class="datagrid-header">
                    <div>
                        <div></div>
                        <div class="picture"></div>
                        <div v-bind:class="[ paginator.sort == 'name' ? 'active' : '', paginator.order ]">
                            <span data-sort="name" @click="setOrder($event)">Nom du Tag</span>
                        </div>
                        <div v-bind:class="[ paginator.sort == 'slug' ? 'active' : '', paginator.order ]">
                            <span data-sort="slug" @click="setOrder($event)">Slug</span>
                        </div>
                        <div class="actions"></div>
                        <div></div>
                    </div>
                </div>
                <div class="datagrid-body">
                    <div v-for="item in resources" @dblclick="edit(item.id)" v-bind:class="setClassDataRaw( 'weeboxcore.tag.view', item.id )">
                        <div></div>
                        <div class="picture">
                            <figure>
                                <i class="icon icon-icon_tags"></i>
                            </figure>
                        </div>
                        <div data-field="name">{{ item.name }}</div>
                        <div data-field="slug">{{ item.slug }}</div>
                        <div class="actions">
                            <ul>
                                <li v-if="$aclInterfaceValidator('weeboxcore.tag.delete',item.id)"><button @click="remove(item.id)"><icon name="trash-01"/></button></li>
                                <li v-if="$aclInterfaceValidator('weeboxcore.tag.update',item.id)"><button @click="edit(item.id)"><icon name="pencil-02"/></button></li>
                            </ul>
                        </div>
                        <div></div>
                    </div>
                </div>
            </div>
            </section>

            <component-paginator v-model="paginator" v-on:refresh="refresh"></component-paginator>

        </div>
    </div>
</template>
<script>
    import TagService from './TagService.js';
    import Index from '../../../layouts/Index.vue';

    export default {
        extends: Index,
        data () {
            return {
            }
        },
        mounted: function(){
            this.refresh()
        },
        methods: {
            getResource: function(){
                return TagService;
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/modules/config/tag/Index.vue